import { UncontrolledTooltip } from 'reactstrap';

export function QualQuizDisabledTooltip() {
  return (
    <UncontrolledTooltip
      placement="top"
      target="qual-daily-quiz-history-content"
    >
      <span>
        Please finish the current qual daily before reviewing or re-taking old
        dailys.
      </span>
    </UncontrolledTooltip>
  );
}
export function QuizDisabledTooltip() {
  return (
    <>
      <UncontrolledTooltip placement="top" target="daily-quiz-history-content">
        <span>
          Please finish the current daily before reviewing or re-taking old
          dailys.
        </span>
      </UncontrolledTooltip>
    </>
  );
}
